
        // Import the functions you need from the SDKs you need
        import { initializeApp } from "https://www.gstatic.com/firebasejs/12.4.0/firebase-app.js";
        import { getAnalytics } from "https://www.gstatic.com/firebasejs/12.4.0/firebase-analytics.js";
        // TODO: Add SDKs for Firebase products that you want to use
        // https://firebase.google.com/docs/web/setup#available-libraries

        // Your web app's Firebase configuration
        // For Firebase JS SDK v7.20.0 and later, measurementId is optional
        const firebaseConfig = {
            apiKey: "AIzaSyAtHrhdM50RrdLUKi0k-jixlS5JgG1C2Ro",
            authDomain: "women-s-bible-web.firebaseapp.com",
            projectId: "women-s-bible-web",
            storageBucket: "women-s-bible-web.firebasestorage.app",
            messagingSenderId: "198897586551",
            appId: "1:198897586551:web:b2096d93c9040c587c9172",
            measurementId: "G-1BFWSWG3EE"
        };

        // Initialize Firebase
        const app = initializeApp(firebaseConfig);
        const analytics = getAnalytics(app);
    